// Zuordnung Modul-Key (aus /users/me/modules) -> Route-Pfad.
// Wird für die modulbasierte Routen-Freigabe (ProtectedRoute) verwendet.
export const MODULE_ROUTES = {
  dashboard: "/",
  products: "/artikel",
  warehouse: "/lagerverwaltung",
  pallets: "/paletten",
  suppliers: "/lieferanten",
  "purchase-orders": "/einkauf",
  postens: "/posten",
  parties: "/parteien",
  sales: "/verkauf",
  "shipping-monitor": "/versand/monitor",
  "picking-list": "/pickliste",
  customers: "/kunden",
  returns: "/retouren",
  marketplaces: "/marktplaetze",
  "ebay-queue": "/ebay",
  payouts: "/abrechnungen",
  accounting: "/buchhaltung",
  reports: "/berichte",
  analytics: "/auswertungen",
  companies: "/firmen",
  users: "/benutzer",
  settings: "/einstellungen",
};
